import "./products.css";
import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import TitleBox from "../../../components/TitleBox/TitleBox";
import ProductCard from "../../../components/ProductCard/ProductCard";
import { productsImage } from "../../../assets/images/productsImg";
import { productsDetail } from "../../../assets/images/productsDetail";
import ProductGalleryLightbox from "../../../components/ProductGalleryLightbox/ProductGalleryLightbox";
import { ModalContextValue } from "../../../context/ModalContext";

function Products() {
  const { t } = useTranslation();
  const { setOpenModal } = ModalContextValue();
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(0);

  const minibusBrands =
    productsDetail.find((product) => product.productId === 2)?.brands || [];

  const productCards = [
    {
      key: "bus",
      image: productsImage.bus,
      text: t("products_bus"),
    },
    {
      key: "minibus",
      image: productsImage.minibus,
      text: t("products_minibus"),
      tags: minibusBrands,
      badgeText: t("products_preview_badge"),
      overlayTitle: t("products_preview_title"),
      overlayHint: t("products_preview_hint"),
      detailLink: "product-detail/2",
      detailLinkLabel: t("products_preview_action"),
    },
    {
      key: "truck",
      image: productsImage.kamyon,
      text: t("products_truck"),
    },
    {
      key: "aviation",
      image: productsImage.havacilik,
      text: t("products_aviation"),
    },
    {
      key: "tractor",
      image: productsImage.traktor,
      text: t("products_tractor"),
    },
    {
      key: "electric-vehicle",
      image: productsImage.elekrikli_arac,
      text: t("products_electric_vehicle"),
    },
    {
      key: "car",
      image: productsImage.otomobil,
      text: t("products_car"),
    },
  ];

  useEffect(() => {
    return () => {
      setOpenModal(false);
    };
  }, [setOpenModal]);

  function handleOpenBrandGallery(brand) {
    setSelectedBrand(brand);
    setSelectedSlideIndex(0);
    setOpenModal(true);
  }

  function handleCloseBrandGallery() {
    setSelectedBrand(null);
    setSelectedSlideIndex(0);
    setOpenModal(false);
  }

  return (
    <div className="front-container-products">
      <div className="header-title">
        <TitleBox title={t("products")} />
      </div>
      <div className="images-container">
        {productCards.map((product) => (
          <div key={product.key} className="product-card-slot">
            <ProductCard
              image={product.image}
              text={product.text}
              tags={product.tags}
              badgeText={product.badgeText}
              overlayTitle={product.overlayTitle}
              overlayHint={product.overlayHint}
              detailLink={product.detailLink}
              detailLinkLabel={product.detailLinkLabel}
              onTagClick={handleOpenBrandGallery}
            />
          </div>
        ))}
      </div>

      <ProductGalleryLightbox
        brand={selectedBrand}
        index={selectedSlideIndex}
        open={Boolean(selectedBrand)}
        onClose={handleCloseBrandGallery}
      />
    </div>
  );
}

export default Products;
